// @ts-nocheck
import useIsTheme from "@toolkit/Framework/Common/Hooks/useIsTheme";

const useIsCSDS = () => useIsTheme("csds");

export default useIsCSDS;
